import React from 'react';
import './Button.scss';


const Button = ({ onClick, text, Icon, showButton }) => {
  return (
    <div className={`button-with-text ${showButton ? "selected" : ""}`} onClick={onClick}>
    <div className="Button" >
      <div className="Button-icon">
        <Icon />
      </div>
    </div>
      <div className="Button-text">{text}</div>
      </div>
  );
};

export default Button;
